/* OBS global: campaign attribution, navigation drawer + delivery-fee lookup. */
(() => {
  // Keep the ad's campaign parameters for the whole visit: the order form sends them with the order,
  // even when the customer lands on the homepage and orders from a product page.
  try {
    const q = [...new URLSearchParams(location.search)].filter(([k]) => /^utm_|^fbclid$/.test(k));
    if (q.length && !sessionStorage.getItem('obs_utm')) sessionStorage.setItem('obs_utm', JSON.stringify(Object.fromEntries(q)));
  } catch (e) { /* storage blocked: the product page still reads its own URL */ }
  const drawer = document.getElementById('obs-drawer');
  if (drawer) {
    const openBtn = document.querySelector('[data-obs-drawer-open]');
    const set = (open) => {
      drawer.toggleAttribute('open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      openBtn && openBtn.setAttribute('aria-expanded', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) drawer.querySelector('[data-obs-drawer-close]:not(.obs-drawer__scrim)').focus();
      else openBtn && openBtn.focus();
    };
    openBtn && openBtn.addEventListener('click', () => set(true));
    drawer.addEventListener('click', (e) => { if (e.target.closest('[data-obs-drawer-close]')) set(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.hasAttribute('open')) set(false); });
  }

  document.querySelectorAll('[data-obs-feecheck]').forEach((box) => {
    const sel = box.querySelector('[data-obs-wilaya]');
    const out = box.querySelector('[data-obs-feeout]');
    const isAr = document.documentElement.lang.startsWith('ar');
    const unit = isAr ? 'دج' : 'DA';
    let data = null;
    const load = () => data ? Promise.resolve(data) : fetch(box.dataset.src).then((r) => r.json()).then((j) => {
      data = j;
      j.w.forEach((w) => {
        const o = document.createElement('option');
        o.value = w.c; o.textContent = String(w.c).padStart(2, '0') + ' · ' + (isAr ? w.ar : w.fr);
        sel.appendChild(o);
      });
    });
    new IntersectionObserver(([e], obs) => { if (e.isIntersecting) { load(); obs.disconnect(); } }, { rootMargin: '300px' }).observe(box);
    sel.addEventListener('change', () => {
      const w = data && data.w.find((x) => String(x.c) === sel.value);
      if (!w) return;
      const n = (v) => v.toLocaleString('fr-FR').replace(/[\s\u00a0\u202f]/g, '\u202f') + '\u00a0' + unit;
      out.innerHTML = w.h == null
        ? `<span>${out.dataset.na || '—'}</span>`
        : `<span>${box.dataset.home || 'Domicile'} <b>${n(w.h)}</b></span><span>${box.dataset.desk || 'Bureau'} <b>${n(w.d)}</b></span>`;
    });
  });
})();
